import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { backendRequest } from '@/stores/thunks';
import i18n from 'i18n-js';
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import BasicButton from "@/components/basic/BasicButton";
import CancelButton from "@/components/basic/CancelButton";

export default function ModalResetPW({ route, navigation, updateType }) {
    const dispatch = useDispatch()

    const { mail } = route.params
    console.log(mail)

    const [sent, setSent] = useState(false);
    const [email, setEMail] = useState(mail);

    return (
        <View className="flex-1 bg-[#00000050] justify-center">
            {sent ? (
                <VStack space='lg' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                    <Text bold className="text-2xl text-secondary-900 bg-secondary-50">{i18n.t('login.sentTitle')}</Text>
                    <Text className="text-black font-[400] text-xl">{i18n.t('login.sentInfo')}</Text>
                    <BasicButton onPress={() => { navigation.goBack() }} text={i18n.t('login.ok')} />
                </VStack>
            ) : (
                <VStack space='lg' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                    <Text bold className="text-2xl text-secondary-900 bg-secondary-50">{i18n.t('login.resetTitle')}</Text>
                    <Text className="text-black font-[400] text-xl">{i18n.t('login.resetInfo')}</Text>
                    <View className="w-[100%]">
                        <FloatingLabelInput label={i18n.t('login.email')} textContentType='emailAddress' autoCapitalize='none' keyboardType='email-address' autoCorrect={false} autoCompleteType='email' placeholder={i18n.t('login.email')} onChangeText={setEMail} value={email} />
                    </View>
                    <BasicButton onPress={() => { dispatch(backendRequest('RESET_PW', '/user/password/reset/mail', { mail: email }, 'PUT', false)); setSent(true) }} text={i18n.t('login.reset')} />
                    <CancelButton onPress={() => { navigation.goBack() }} text={i18n.t('login.cancel')} />
                </VStack>
            )}
        </View>
    );
}
